// Auto generated file, do not manually modify!
// com.hotpads.adproducts.api.web.user.billing.handler.AdproductsEventTrackingApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { EnterprisePageFeature } from '../..';

interface TrackPageVisitParams {
  page: EnterprisePageFeature;
}

export const AdproductsEventTrackingApiHandler_trackPageVisit_Path = '/api/web/v1/users/tracking/trackPageVisit';

/**
 * Track enterprise page visit
 */
export const AdproductsEventTrackingApiHandler_trackPageVisit = (
  getParams: TrackPageVisitParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<TrackPageVisitParams, never, void>(
    {
      getParams: getParams,
      endpoint: AdproductsEventTrackingApiHandler_trackPageVisit_Path,
      method: 'POST',
      contextPath: '/adproducts',
    },
    client,
  );
};
